import { LinkEventMapping } from '../types/propTypes';

const linkEventsRegistry: LinkEventMapping = {};

export default linkEventsRegistry;
